import { useEffect, useState } from 'react';
import { onSnapshot, orderBy, query } from 'firebase/firestore';
import { matchesCol } from './matches';
import type { Match } from './types';

export function useMatches(tournamentId: string | undefined): {
  matches: Match[] | undefined;
  error: Error | null;
} {
  const [matches, setMatches] = useState<Match[] | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    setError(null);
    if (!tournamentId) {
      setMatches([]);
      return;
    }
    const q = query(matchesCol(tournamentId), orderBy('round'), orderBy('slot'));
    return onSnapshot(
      q,
      (snap) => setMatches(snap.docs.map((d) => d.data())),
      (err) => setError(err)
    );
  }, [tournamentId]);

  return { matches, error };
}
